export function compareStrings() {
    var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var dest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return src.localeCompare(dest, 'pt-br', { sensitivity: 'base' });
}